import type { CustomerLoginSettings } from "./customer-login-interfaces";

export const getCustomerLoginSettings = async (apiUrl: string, currentUrl: string): Promise<CustomerLoginSettings> => {
  return fetch(`${apiUrl}/api/customerlogin/LoginSettings?currentUrl=${currentUrl}`)
    .then((res) => {
      return res.json();
    })
    .then((data: CustomerLoginSettings) => {
      return data;
    });
};

const CompanyAdminSessionKey = "ice-company-admin-session-key";

type CompanyAdminSession = {
  isCompanyAdmin: boolean;
  userId: string;
  expiresAt: number;
};

const expirationTimeMinutes = 30;

export const checkIfCompanyAdmin = async (token: string | undefined, userId: string): Promise<boolean> => {
  if (!token) {
    return false;
  }

  const sessionValue = sessionStorage.getItem(CompanyAdminSessionKey);
  if (sessionValue) {
    const sessionObj: CompanyAdminSession = JSON.parse(sessionValue);
    if (sessionObj.userId === userId && Date.now() < sessionObj.expiresAt) {
      return sessionObj.isCompanyAdmin;
    }
  }

  const response = await fetch(`/api/customer/checkifcompanyadmin`, {
    method: "get",
    cache: "no-cache",
    headers: new Headers({
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    }),
  });

  const data: boolean = response.ok ? await response.json() : false;
  const newSessionValue: CompanyAdminSession = {
    isCompanyAdmin: data,
    userId: userId,
    expiresAt: Date.now() + expirationTimeMinutes * 60 * 1000,
  };
  sessionStorage.setItem(CompanyAdminSessionKey, JSON.stringify(newSessionValue));

  return data;
};
